import React from "react";
import { Button, Modal } from "semantic-ui-react";
import ProgressLoader from "../Common/ProgressLoader";

interface EnableFreeEquipmentPlacementProps {
  loading: boolean;
  editName: any;
  editId: any;
  openEnableFreeEquipmentPlacementModal: boolean;
  handleCancel: () => void;
  updateFreeEquipmentPlacementStatus: () => Promise<void>;
  freeEquipmentPlacementEnabled: boolean;
}

const EnableFreeEquipmentPlacementModal = (props: EnableFreeEquipmentPlacementProps ) => {
  const {
    handleCancel,
    updateFreeEquipmentPlacementStatus,
    openEnableFreeEquipmentPlacementModal,
    editName,
    editId,
    freeEquipmentPlacementEnabled,
    loading,
  } = props;

  return (
    <Modal
      centered
      open={openEnableFreeEquipmentPlacementModal}
      onClose={handleCancel}
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Modal.Content>
        <div className="close-button">
          <button
            className="email-activity-close-button"
            onClick={handleCancel}
          >
            
          </button>
        </div>
        <ProgressLoader loading={loading} size="small" />
        <div className="word-wrap">
        {`Are you sure you want to ${
          freeEquipmentPlacementEnabled ? "ENABLE" : "DISABLE"
        } Free Equipment Placement for ${editName} ( ID - ${editId} )?`}
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancel}>CANCEL</Button>
        <Button onClick={updateFreeEquipmentPlacementStatus} color="blue">
          YES
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EnableFreeEquipmentPlacementModal